import React from "react";
import { Redirect, Link } from "react-router-dom";
import Header from "../Header";
import Common from "./../Common";
import { Loading } from "./UI";
class Login extends Common {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.logout();
  }
  render() {
    return (
      <div className="mainContent-panel-wrap">
        <Header />
        <div className="d-flex justify-content-center align-items-center">
          <Loading />
        </div>
      </div>
    );
  }
}
export default Login;
